import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import {get, isEqual, omit} from 'lodash';
import classnames from 'classnames';
import {Select} from 'ui-library';
import i18n from 'i18n';

import {getStatics} from 'config/app';
import {Toggle} from 'modules/legacy/js/lib/components';

import styles from './AdvertisersPermissionsSelector.less';

const DEFAULT_LAYOUT_FOR_EMPTY_PERMISSIONS = 'admin';
const DEFAULT_LAYOUT_FOR_NON_EMPTY_PERMISSIONS = 'custom';

const Selector = createClass({
  propTypes: {
    selectedLayout: PropTypes.string,
    selectedPermissions: PropTypes.object,
    onChange: PropTypes.func
  },

  getDefaultProps() {
    return {selectedLayout: DEFAULT_LAYOUT_FOR_EMPTY_PERMISSIONS};
  },

  getInitialState() {
    const {selectedLayout, selectedPermissions} = this.props;

    return {
      selectedLayout: selectedPermissions ? this.getLayoutByPermissions(selectedPermissions) : selectedLayout,
      selectedPermissions: selectedPermissions || this.getPermissionsByLayout(DEFAULT_LAYOUT_FOR_EMPTY_PERMISSIONS)
    };
  },

  componentDidMount() {
    this.props.onChange(this.state.selectedPermissions);
  },

  onLayoutSelected(selectedLayout) {
    const {onChange} = this.props;
    const selectedPermissions = this.getPermissionsByLayout(selectedLayout);

    if (!selectedPermissions) return;

    this.setState({selectedLayout, selectedPermissions}, () => onChange(selectedPermissions));
  },

  onPermissionToggle(permission) {
    const {onChange} = this.props;
    const previousValue = !!this.state.selectedPermissions[permission];
    const newPermissions = {
      ...this.state.selectedPermissions,
      [permission]: !previousValue
    };

    const permissionsWithoutFalsyValues = omit(newPermissions, p => !p);

    this.setState({
      selectedPermissions: permissionsWithoutFalsyValues,
      selectedLayout: this.getLayoutByPermissions(permissionsWithoutFalsyValues)
    }, () => onChange(permissionsWithoutFalsyValues));
  },

  getPermissionsByLayout(layoutName) {
    const {advertiserPermissions} = getStatics();
    if (layoutName === DEFAULT_LAYOUT_FOR_NON_EMPTY_PERMISSIONS) return;
    return advertiserPermissions.layouts[layoutName].permissions;
  },

  getLayoutByPermissions(permissions) {
    const {advertiserPermissions} = getStatics();
    const layoutName = Object.keys(advertiserPermissions.layouts).reduce((name, currentLayoutName) => {
      const currentLayoutPermissions = this.getPermissionsByLayout(currentLayoutName);

      if (isEqual(permissions, currentLayoutPermissions)) return currentLayoutName;
      return name;
    }, DEFAULT_LAYOUT_FOR_NON_EMPTY_PERMISSIONS);

    return layoutName;
  },

  render() {
    const {selectedLayout, selectedPermissions} = this.state;
    return (
      <div>
        <LayoutSelector
          selectedLayout={selectedLayout}
          onChange={this.onLayoutSelected}
        />

        <div className='vf-scrolly' style={{height: '45vh', padding: '0 2rem 0 0'}}>
          <Options selectedPermissions={selectedPermissions} onChange={this.onPermissionToggle} />
        </div>

        <div className={classnames('padding-Hx margin-top-1x', styles.disclaimer)}>
          {i18n.get('ADV_BRANDS_USER_PERMISSIONS_ALL_USERS_CAN_SEE_STATS')}
        </div>
      </div>
    );
  }
});

const LayoutSelector = ({selectedLayout, onChange}) => {
  const {advertiserPermissions} = getStatics();
  const {layouts} = advertiserPermissions;
  const options = Object.keys(layouts).reduce((result, key) => {
    result[key] = layouts[key].name;
    return result;
  }, {custom: i18n.get('ADV_BRANDS_USER_PERMISSIONS_CUSTOM_LABEL')});

  return (
    <div className='margin-bottom-1x'>
      <div className='flex between-xs'>
        <h4 className='vf-font-bold width-auto'>
          {i18n.get('ADV_BRANDS_USER_PERMISSIONS_PERMISSIONS_LABEL')}
        </h4>

        <Select
          value={selectedLayout}
          onChange={ev => onChange(ev.target.value)}
          buttonSize='sm'
          title={i18n.get('ADV_BRANDS_USER_PERMISSIONS_PERMISSIONS_TYPE_LABEL')}
          className='margin-left-Hx'
          options={options}
        />
      </div>
    </div>
  );
};

const Options = ({selectedPermissions, onChange}) => {
  const {advertiserPermissions} = getStatics();
  const {permissions} = advertiserPermissions;
  const options = Object.keys(permissions).map((key) => {
    return (
      <div className='col margin-bottom-1x' key={key}>
        <div className='flex'>
          <h5>{get(permissions, `${key}.name`)}</h5>
          <Toggle
            className='margin-Hx'
            value={!!selectedPermissions[key]}
            onClick={() => onChange(key)}
          />
        </div>

        <div className='vf-text-gray-dark width100'>
          {get(permissions, `${key}.description`)}
        </div>
      </div>
    );
  });

  return <div>{options}</div>;
};

export default Selector;
